import api from "./api";
import { getApiErrorMessage } from "../utils/apiError";
import type { ProfileResponse, ProfileUpdateData } from "../types/models";

export const profileService = {
  /**
   * Get current user profile information
   * GET /api/auth/me
   */
  async getProfile(): Promise<ProfileResponse> {
    try {
      const response = await api.get<ProfileResponse>("/auth/me");
      return response.data;
    } catch (error) {
      const message = getApiErrorMessage(error, "Failed to get profile information");
      throw new Error(message);
    }
  },

  /**
   * Update current user profile (email, full_name, locale)
   * PUT /api/auth/me
   */
  async updateProfile(data: ProfileUpdateData): Promise<ProfileResponse> {
    try {
      const response = await api.put<ProfileResponse>("/auth/me", data);
      return response.data;
    } catch (error) {
      const message = getApiErrorMessage(error, "Failed to update profile");
      throw new Error(message);
    }
  },

  /**
   * Change password for the current user (invalidates existing JWTs).
   * POST /api/auth/change-password
   */
  async changePassword(payload: {
    current_password: string;
    new_password: string;
    confirm_password: string;
  }): Promise<void> {
    try {
      await api.post<{ message: string }>("/auth/change-password", payload);
    } catch (error) {
      const message = getApiErrorMessage(error, "Failed to update password");
      throw new Error(message);
    }
  },
};
